import { EpJsConfig } from '../models/config.model';
import { singleton } from 'tsyringe';
import { ConfigUtilService } from '../services/config/config-util.service';

@singleton()
export class EpLogger {
  get config(): EpJsConfig{
    return this.configUtilService.getConfig();
  }
  constructor(private configUtilService?: ConfigUtilService) {
  }

  log(...messages: any[]) {
    if (this.config.loggingEnabled) {
      console.log(messages);
    }
  }

  warn(...messages: any[]) {
    if (this.config.loggingEnabled) {
      console.warn(messages);
    }
  }

  error(...messages: any[]) {
    if (this.config.loggingEnabled) {
      console.error(messages);
    }
  }
}
